import { environment } from '../../config/environment';
import { authService } from '../../services/auth.service';

import './AccessDenied.css';

/**
 * AccessDenied Component
 *
 * Displays an access denied page when user lacks permissions to access the application.
 * Provides logout functionality with support for both Azure AD and development auth modes.

 * <AccessDenied />
 */
export const AccessDenied = () => {
  const handleLogout = () => {
    if (environment.devAuthOff) {
      window.location.reload();
    } else {
      authService.logout();
    }
  };

  return (
    <div className="access-denied-container">
      <div className="access-denied-content">
        <div className="warning-icon">⚠</div>
        <h2>Доступ заборонено</h2>
        <p>Ви не маєте дозволу на доступ до цієї програми.</p>
        <p>Доступ заборонено або можлива проблема з доступом до сервісу. Будь ласка, зверніться до адміністратора.</p>

        <div className="actions">
          <button className="logout-button" onClick={handleLogout}>
            Вийти
          </button>
        </div>
      </div>
    </div>
  );
};
